import { c as _c } from "react/compiler-runtime";
import { ColorVariant } from "@shared/types";
export function HeroTitle(t0) {
  const $ = _c(28);
  const {
    variant,
    title,
    subtitle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      default: null,
      primary: "linear-gradient(180deg, hsl(var(--primary-200)) 45.7%, hsl(var(--primary-400)) 70.69%, hsl(var(--primary-600)) 90.34%)",
      secondary: "linear-gradient(180deg, hsl(var(--secondary-200)) 45.7%, hsl(var(--secondary-400)) 70.69%, hsl(var(--secondary-600)) 90.34%)",
      tertiary: "linear-gradient(180deg, hsl(var(--tertiary-200)) 45.7%, hsl(var(--tertiary-400)) 70.69%, hsl(var(--tertiary-600)) 90.34%)",
      quaternary: "linear-gradient(180deg, hsl(var(--quaternary-200)) 45.7%, hsl(var(--quaternary-400)) 70.69%, hsl(var(--quaternary-600)) 90.34%)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const backgroundMap = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      default: null,
      primary: "hsl(var(--primary-800))",
      secondary: "hsl(var(--secondary-800))",
      tertiary: "hsl(var(--tertiary-800))",
      quaternary: "hsl(var(--quaternary-800))"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const shadowMap = t2;
  if (variant === "default") {
    let t3;
    if ($[2] !== subtitle) {
      t3 = subtitle && <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold !leading-[115%]">{subtitle}</h2>;
      $[2] = subtitle;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== title) {
      t4 = <h1 className="text-white text-5xl md:text-7xl font-bold !leading-[115%]">{title}</h1>;
      $[4] = title;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
      t5 = <div>{t3}{t4}</div>;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t3;
  if ($[9] !== subtitle || $[10] !== variant) {
    t3 = subtitle && <div className="relative font-bold text-[54px] lg:text-6xl leading-[62px] sm:leading-[85px]"><span className="absolute inset-0" style={{
        color: shadowMap[variant] as string,
        transform: "translateY(5px)"
      }}>{subtitle}</span><span className="relative text-gradient" style={{
        background: backgroundMap[variant] as string
      }}>{subtitle}</span></div>;
    $[9] = subtitle;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = shadowMap[variant] as string;
  let t5;
  if ($[12] !== t4) {
    t5 = {
      color: t4,
      transform: "translateY(5px)"
    };
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5 || $[15] !== title) {
    t6 = <span className="absolute inset-0" style={t5}>{title}</span>;
    $[14] = t5;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = backgroundMap[variant] as string;
  let t8;
  if ($[17] !== t7) {
    t8 = {
      background: t7
    };
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8 || $[20] !== title) {
    t9 = <span className="relative text-gradient" style={t8}>{title}</span>;
    $[19] = t8;
    $[20] = title;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t6 || $[23] !== t9) {
    t10 = <div className="relative font-bold text-[54px] sm:text-[92px] leading-[62px] sm:leading-[85px]">{t6}{t9}</div>;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3) {
    t11 = <>{t3}{t10}</>;
    $[25] = t10;
    $[26] = t3;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}